import React from 'react';

import { useWebPlayerContext } from 'application/providers/WebPlayerProvider';

import { EPlayState } from '@player-core/use-player-frame';
import { SILENT_MEDIAFILE_ID } from 'application/consts';
import { TEXTS } from '../texts';
import WebPlayerPureDislikeButton from '../PureDisikeButton';

const getDislikeButtonHint = (isDisabled: boolean, playState: EPlayState, isConnected: boolean) => {
  if (isDisabled) {
    if (playState !== EPlayState.PLAY) {
      return TEXTS.PLAY_FOR_REMOVE;
    }
    if (!isConnected) {
      return TEXTS.REMOVE_DISABLED_OFFILE;
    }
    return TEXTS.PLAYER_PROCESSING;
  }
  return undefined;
};

const WebPlayerDislikeButton: React.FC = () => {
  const { mediaFile, streamId, actions, actionButtonsDisabled, playState, isConnected } = useWebPlayerContext();

  const onDislikeClick = () => {
    actions?.nextTrack();
  };

  const isSilentTrack = mediaFile?.id?.toString() === SILENT_MEDIAFILE_ID.toString();

  return (
    <WebPlayerPureDislikeButton
      id={mediaFile?.id}
      streamId={streamId}
      onDislike={onDislikeClick}
      isDisabled={actionButtonsDisabled || isSilentTrack}
      hint={getDislikeButtonHint(actionButtonsDisabled, playState, isConnected)}
    />
  );
};

export default WebPlayerDislikeButton;
